import React from 'react'
// import { HexGrid, Layout, Hexagon, Text, Pattern, Path, Hex } from 'react-hexgrid';

export default function ECupCommitteePage({ toast }) {
    return (
        <>
            <div className='row '>
                <h2 className='roboto-custom-black col-sm-10 col-12 fw-bold my-2' >لجنة كأس الإمارات العالمي لجمال الخيل العربية</h2>
                <h5 className='roboto-custom-black col-sm-10 col-12 fw-bold my-2' >برئاسة / نائب رئيس مجلس إدارة جمعية الإمارات للخيول العربية  <span className='text-success'>الشيخ زايد بن حمد ال نهيان،</span> وعضوية كل من</h5>
                <table className="table table-striped mt-4">
                    <tbody>
                        <tr>
                            <td className='fw-bold' >سعادة/ محمد أحمد الحربي     </td>
                            <td >مدير عام جمعية الإمارات للخيول العربية</td>
                            <td className='fw-bold' >نائباً الرئيس</td>
                        </tr>
                        <tr>
                            <td className='fw-bold' >الدكتور/ عبد الوهاب بن علي عميرة</td>
                            <td ></td>
                            <td className='fw-bold' >عضواً</td>
                        </tr>
                        <tr>
                            <td className='fw-bold' >السيد / عيظه طالب المنهالي</td>
                            <td ></td>
                            <td className='fw-bold' >عضواً</td>
                        </tr>
                        <tr>
                            <td className='fw-bold' >السيدة/ ديدريه هايت</td>
                            <td ></td>
                            <td className='fw-bold' >عضواً</td>
                        </tr>
                        <tr>
                            <td className='fw-bold' >السيدة / الاء السيد</td>
                            <td ></td>
                            <td className='fw-bold' >عضواً ومقرراً</td>
                        </tr>

                    </tbody>
                </table>
            </div>
            {/* <div className='text-center my-4' >
                <HexGrid width={'100%'} viewBox="-900 -500 1400 600">
                    <Layout size={{ x: 140, y: 140 }} flat={true} spacing={1.1} origin={{ x: 0, y: 0 }}>
                        <Hexagon q={-1} r={-1} s={1} style={{ fill: '#198754' }} >
                            <Text style={{ fill: '#fff', fontSize: 20, fontWeight: 'bold' }} y={-80} >سعادة   </Text>
                            <Text style={{ fill: '#fff', fontSize: 20, fontWeight: 'bold' }} y={-50} >محمد أحمد الحربي   </Text>
                            <Text style={{ fill: '#fff', fontSize: 20, fontWeight: 'bold' }} y={-20} > مدير عام    </Text>
                            <Text style={{ fill: '#fff', fontSize: 20, fontWeight: 'bold' }} y={0} > جمعية الإمارات للخيول العربية   </Text>
                            <Text style={{ fill: '#fff', fontSize: 20, fontWeight: 'bold' }} y={40} > نائباً الرئيس</Text>
                        </Hexagon>
                        <Hexagon q={0} r={-1} s={0} style={{ fill: '#198754' }} >
                            <Text style={{ fill: '#fff', fontSize: 20, fontWeight: 'bold' }} y={-80} >الدكتور   </Text>
                            <Text style={{ fill: '#fff', fontSize: 20, fontWeight: 'bold' }} y={0} >عبد الوهاب بن علي عميرة    </Text>
                            <Text style={{ fill: '#fff', fontSize: 20, fontWeight: 'bold' }} y={80} > عضوأ    </Text>
                        </Hexagon>
                        <Hexagon q={-2} r={0} s={1} style={{ fill: '#198754' }} >
                            <Text style={{ fill: '#fff', fontSize: 20, fontWeight: 'bold' }} y={-80} >السيد   </Text>
                            <Text style={{ fill: '#fff', fontSize: 20, fontWeight: 'bold' }} y={0} >عيظه طالب المنهالي</Text>
                            <Text style={{ fill: '#fff', fontSize: 20, fontWeight: 'bold' }} y={80} > عضوأ    </Text>
                        </Hexagon>
                        <Hexagon q={-3} r={1} s={1} style={{ fill: '#198754' }} >
                            <Text style={{ fill: '#fff', fontSize: 20, fontWeight: 'bold' }} y={-80} >السيدة   </Text>
                            <Text style={{ fill: '#fff', fontSize: 20, fontWeight: 'bold' }} y={0} >ديدريه هايت</Text>
                            <Text style={{ fill: '#fff', fontSize: 20, fontWeight: 'bold' }} y={80} > عضوأ    </Text>
                        </Hexagon>
                        <Hexagon q={1} r={-1} s={1} style={{ fill: '#198754' }} >
                            <Text style={{ fill: '#fff', fontSize: 20, fontWeight: 'bold' }} y={-80} >السيدة   </Text>
                            <Text style={{ fill: '#fff', fontSize: 20, fontWeight: 'bold' }} y={0} >الاء السيد</Text>
                            <Text style={{ fill: '#fff', fontSize: 20, fontWeight: 'bold' }} y={80} > عضواً و مقرراً    </Text>
                        </Hexagon>
                    </Layout>
                </HexGrid>


            </div> */}
        </>
    )
}
